import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import shortid from "shortid";
import LeaveSessionService from "../../../Services/LeaveSessionService";
import LeavetypeService from "../../../Services/LeavetypeService";
import DataParser from "../../../utlits/Dataparser";
import RepeaterForm from "./Repeater/RepeaterForm";
import PolicyServices from "../../../Services/PolicyServices";
import UserMultiSelect from "../../Reuseable/UserMultiSelect";
import { message, Tooltip, Switch, Select } from "antd";
import moment from "moment";
import UserService from "../../../Services/UserService";

const { Option } = Select;

const TABS = [
  { label: "Basic Details", icon: "basicdetails.svg" },
  { label: "Leaves Policy", icon: "leavepolicy.svg" },
  { label: "Attendance Policy", icon: "attednacepolicy.svg" },
];

const AddPolicy = () => {
  const navigate = useNavigate();
  const compid = DataParser.CompanyId();
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [dataSubmitting, setDataSubmitting] = useState(false);
  const [title, setTitle] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [lateComingLenency, setLateComingLenency] = useState("");
  const [lateComingMontlyBudget, setLateComingMontlyBudget] = useState("");
  const [lateComersPlenty, setLateComersPlenty] = useState("");
  const [maxLeniencyTime, setMaxLeniencyTime] = useState("");
  const [addLateComersPenalty, setAddLateComersPenalty] = useState("");
  const [overtime_allowed, setOvertimeAllowed] = useState(false);
  const [overtimeLogics, setOvertimeLogics] = useState([
    { day_type: "Active Days", active: false, hourly_adjustment: false, overtime_payment: false, leave_adjustment: false, leave_unit_hours: 1, multiplier: 1, rate_payment: 0, adjustment_priority: "Hourly Adjustment", adjustment_cycle: "Monthly" },
    { day_type: "Off Days", active: false, hourly_adjustment: false, overtime_payment: false, leave_adjustment: false, leave_unit_hours: 1, multiplier: 1, rate_payment: 0, adjustment_priority: "Hourly Adjustment", adjustment_cycle: "Monthly" },
    { day_type: "Holidays", active: false, hourly_adjustment: false, overtime_payment: false, leave_adjustment: false, leave_unit_hours: 1, multiplier: 1, rate_payment: 0, adjustment_priority: "Hourly Adjustment", adjustment_cycle: "Monthly" },
  ]);
  const [error, setError] = useState("");
  const [activeLeaveSession, setActiveLeaveSession] = useState("");
  const [allPolicies, setAllPolicies] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [activeLeaveFilter, setActiveLeaveFilter] = useState(null);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictInfo, setConflictInfo] = useState({ isBulk: false, firstConflict: null, pendingOptions: [] });

  useEffect(() => {
    getAllLeaveType();
    getCompanyUsers();
    getActiveLeaveSession();
    fetchAllPolicies();
  }, []);

  const fetchAllPolicies = () => {
    PolicyServices.getHRPolicy(compid).then((res) => {
      if (res.data && res.data.HrPolicies) setAllPolicies(res.data.HrPolicies);
    }).catch(err => console.error("Error fetching policies:", err));
  };

  const getActiveLeaveSession = () => {
    LeaveSessionService.getLeaveSeassions(compid).then((res) => {
      const sessions = res.data.Leave_sessions || [];
      const active = sessions.find((s) => s.status === 1);
      setActiveLeaveSession(active
        ? `Active Session: ${moment(active.start_date).format("DD/MM/YYYY")} - ${moment(active.end_date).format("DD/MM/YYYY")}`
        : "No Active Session Found"
      );
    }).catch(err => console.error("Error fetching leave sessions:", err));
  };

  const getAllLeaveType = () => {
    LeavetypeService.getLeaveTypeActive(compid).then((res) => {
      const types = res.data.leavetypes || [];
      setLeaveTypeList(types);
      setInputFields(types.map(lt => ({
        id: shortid.generate(),
        leave_type_id: lt.id,
        leave_type_name: lt.name,
        allowed_leaves: "",
        unit: "",
        carry_forword: "",
        consecutive_allowed: "",
        prorated: "",
        paid_leaves: "",
        encashable: "",
        auto_deduction_late_in: false,
        gender_restriction: "Both",
      })));
    });
  };

  const getCompanyUsers = () => {
    UserService.getCompanyActiveUsers(compid).then((res) => {
      setUsersList((res.data.users || []).map(u => ({
        value: u.id,
        label: `${u.first_name} ${u.last_name}`.trim(),
        initials: `${u.first_name?.[0] || ""}${u.last_name?.[0] || ""}`.toUpperCase(),
      })));
    }).catch(err => console.error("Error fetching company users:", err));
  };

  const handleUserChange = (selectedOptions) => {
    const isAddition = selectedOptions && selectedOptions.length > selectedUsers.length;
    if (isAddition) {
      const addedUsers = selectedOptions.filter(opt => !selectedUsers.some(su => Number(su.value) === Number(opt.value)));
      const conflicts = [];
      for (const addedUser of addedUsers) {
        const found = allPolicies.find(p => p.userIds && p.userIds.some(u => Number(u.user_id) === Number(addedUser.value)));
        if (found) conflicts.push({ user: addedUser, policy: found });
      }
      if (conflicts.length > 0) {
        setConflictInfo({ isBulk: conflicts.length > 1, firstConflict: conflicts[0], pendingOptions: selectedOptions });
        setShowConflictModal(true);
        return;
      }
    }
    setSelectedUsers(selectedOptions);
  };

  const submitPolicy = (e) => {
    e && e.preventDefault();
    setDataSubmitting(true);
    if (!title || title.trim() === "") {
      setError("Policy name is required!");
      setDataSubmitting(false);
      return;
    }
    const Body = {
      company_id: compid,
      name: title.trim(),
      assinged_to: selectedUsers.map((u) => u.value),
      status: isActive ? 1 : 0,
      leave_policy: inputFields,
      attendence_policy: {
        late_coming_time_leniency: lateComingLenency,
        late_coming_monthly_bucket: lateComingMontlyBudget,
        late_coming_penalty: lateComersPlenty,
        max_leniency_time: maxLeniencyTime,
        additional_late_coming_penalty: addLateComersPenalty,
        overtime_allowed: overtime_allowed ? "yes" : "no",
        overtime_logics: overtimeLogics,
      },
    };
    PolicyServices.createHRPolicy(Body)
      .then((res) => {
        setDataSubmitting(false);
        const responseData = res?.data;
        if (responseData === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }
        if (responseData?.Good === true) {
          message.success("Policy created successfully!");
          navigate(`/${DataParser.CompanyIdentifierRole()}/policy`);
        } else {
          message.success(responseData || "Policy created successfully!");
          navigate(`/${DataParser.CompanyIdentifierRole()}/policy`);
        }
      })
      .catch((err) => {
        setDataSubmitting(false);
        console.error("Policy creation error:", err);
        message.error(err.response?.data?.data || err.response?.data?.message || "An error occurred while creating the policy.");
      });
  };

  return (
    <>
      <Helmet>
        <title>Create Policy - Planit</title>
      </Helmet>

      {showConflictModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setShowConflictModal(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Conflict Detected</h5>
                <button type="button" className="btn-close" onClick={() => setShowConflictModal(false)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                {conflictInfo.isBulk ? (
                  <p style={{ fontSize: "14px", color: "#1D1D1D" }}><strong>Multiple users</strong> ({conflictInfo.pendingOptions.length - selectedUsers.length}) are already assigned to existing policies.</p>
                ) : (
                  <p style={{ fontSize: "14px", color: "#1D1D1D" }}>User <strong>{conflictInfo.firstConflict?.user?.label}</strong> is already assigned to:</p>
                )}
                <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: '6px', padding: '8px 12px', marginTop: '8px', fontWeight: '600', color: '#d46b08', fontSize: "13px" }}>
                  {conflictInfo.isBulk ? "Various Existing Policies" : conflictInfo.firstConflict?.policy?.name}
                </div>
                <p style={{ marginTop: '16px', color: '#8c8c8c', fontSize: '13px', marginBottom: 0 }}>
                  {conflictInfo.isBulk ? "Would you like to reassign all of them to this policy?" : "Would you like to reassign them to this policy?"}
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                  style={{ borderRadius: "5px", fontSize: "13px" }}
                  onClick={() => { setSelectedUsers(conflictInfo.pendingOptions); setShowConflictModal(false); }}
                >
                  Reassign
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            {activeLeaveSession && (
              <div style={{ fontSize: "13px", color: "#0DDFAB", fontWeight: 600, marginBottom: "8px" }}>
                {activeLeaveSession}
              </div>
            )}

            {/* Tab Bar */}
            <div className="user-form-tab-bar" style={{ marginTop: "8px" }}>
              <div style={{ display: "flex", flex: 1 }}>
                {TABS.map((tab, i) => (
                  <div key={i} className={`user-form-tab${activeTab === i ? " active" : ""}`} onClick={() => setActiveTab(i)}>
                    <span style={{ display: 'inline-block', width: '16px', height: '16px', flexShrink: 0, backgroundColor: 'currentColor', mask: `url('/assets/images/${tab.icon}') no-repeat center / contain`, WebkitMask: `url('/assets/images/${tab.icon}') no-repeat center / contain`, transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                    {tab.label}
                  </div>
                ))}
              </div>
              {activeTab < TABS.length - 1 ? (
                <button
                  type="button"
                  onClick={() => setActiveTab(activeTab + 1)}
                  style={{ background: "#1D1D1D", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}
                >
                  Next
                </button>
              ) : dataSubmitting ? (
                <button
                  disabled
                  style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", marginLeft: "16px", minWidth: "150px", cursor: "not-allowed" }}
                >
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Creating...
                </button>
              ) : (
                <button
                  type="button"
                  onClick={submitPolicy}
                  style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}
                >
                  Create Policy
                </button>
              )}
            </div>

            {/* Tab 0: Basic Details */}
            {activeTab === 0 && (
              <div className="mt-4">
                <div className="row mb-3" style={{ alignItems: "flex-start" }}>
                  <div className="col-md-6 px-0 pe-4">
                    <div className="float-input-wrap">
                      <input
                        type="text"
                        id="policyName"
                        placeholder=" "
                        className={error ? "is-invalid" : ""}
                        value={title}
                        onChange={(e) => { setTitle(e.target.value); if (e.target.value.trim()) setError(""); }}
                      />
                      <label htmlFor="policyName">
                        Policy Name*
                        <Tooltip title="Enter a unique name to identify this HR policy.">
                          <i className="fa fa-info-circle float-label-helper-icon" />
                        </Tooltip>
                      </label>
                      {error && <small className="text-danger mt-1 d-block">{error}</small>}
                    </div>
                  </div>
                  <div className="col-md-6 px-0 d-flex align-items-center" style={{ height: "44px" }}>
                    <div className="form-check mb-0 d-flex align-items-center" style={{ gap: "8px" }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="enablePolicy"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        style={{ width: "18px", height: "18px", cursor: "pointer", marginTop: "0", flexShrink: 0 }}
                      />
                      <label className="form-check-label mb-0" htmlFor="enablePolicy" style={{ fontSize: "14px", color: "#787878", cursor: "pointer", lineHeight: 1 }}>
                        Do you want enable policy?
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-1" style={{ fontSize: "13px", color: "#555", fontWeight: 500 }}>Assign to Users</div>
                <div className="mb-2" style={{ fontSize: "12px", color: "#888" }}>Only selected users will be affected by this policy</div>
                <div className="row" style={{ alignItems: "flex-start" }}>
                  <div className="col-md-6 px-0 pe-4">
                    <UserMultiSelect
                      options={usersList}
                      value={selectedUsers}
                      onChange={handleUserChange}
                      searchPlaceholder="Search users..."
                      allowSelectAll
                      noInternalPanel
                    />
                  </div>
                  {selectedUsers.length > 0 && (
                    <div className="col-md-6 px-0">
                      <div style={{ border: "1.5px solid #0DDFAB", borderRadius: "8px", padding: "6px 10px", minHeight: "44px", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "6px", position: "relative" }}>
                        <span
                          onClick={() => handleUserChange([])}
                          style={{
                            position: "absolute", top: "-8px", right: "-8px",
                            width: "16px", height: "16px",
                            borderRadius: "50%",
                            backgroundColor: "#0DDFAB", cursor: "pointer",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            color: "#fff", fontSize: "11px", lineHeight: "16px", zIndex: 1,
                            userSelect: "none"
                          }}
                        >×</span>
                        {selectedUsers.map(u => (
                          <span key={u.value} style={{
                            display: "inline-flex", alignItems: "center", gap: "4px",
                            backgroundColor: "#f0fdf9", border: "1px solid #b2f5e8",
                            borderRadius: "4px", padding: "2px 7px", fontSize: "12px", color: "#333"
                          }}>
                            {u.label}
                            <button
                              type="button"
                              onClick={() => handleUserChange(selectedUsers.filter(v => v.value !== u.value))}
                              style={{ border: "none", background: "none", cursor: "pointer", padding: "0", lineHeight: 1, color: "#0DDFAB", fontSize: "15px", display: "flex", alignItems: "center" }}
                            >×</button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Tab 1: Leaves Policy */}
            {activeTab === 1 && (
              <div className="mt-4">
                {/* Leave type filter tabs */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", marginBottom: "24px" }}>
                  <div
                    onClick={() => setActiveLeaveFilter(null)}
                    style={{
                      flex: "1",
                      minWidth: "140px",
                      backgroundColor: "#fff",
                      border: activeLeaveFilter === null ? "2px solid #0DDFAB" : "1px solid #E5E7EB",
                      borderRadius: "8px",
                      padding: "8px 14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#1D1D1D" }}>All Leaves</span>
                    <div style={{
                      width: "28px", height: "28px",
                      borderRadius: "6px",
                      backgroundColor: "rgba(13, 223, 171, 0.1)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "#0DDFAB"
                    }}>
                      <span style={{ display: 'inline-block', width: '14px', height: '14px', flexShrink: 0, backgroundColor: 'currentColor', mask: "url('/assets/images/allleaves.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/allleaves.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                    </div>
                  </div>
                  {inputFields.map(entry => {
                    const isActive = activeLeaveFilter === entry.leave_type_id;
                    const getLeaveIconPath = (name) => {
                      const n = (name || "").toLowerCase();
                      if (n.includes("all")) return "allleaves.svg";
                      if (n.includes("annual")) return "annualeaves.svg";
                      if (n.includes("bereavement")) return "Bereavement.svg";
                      if (n.includes("maternity")) return "maternity.svg";
                      if (n.includes("paternity")) return "paternity.svg";
                      if (n.includes("marriage")) return "marriage.svg";
                      if (n.includes("umrah")) return "umrah.svg";
                      if (n.includes("hajj")) return "hajj.svg";
                      return "leaves.svg";
                    };
                    return (
                      <div
                        key={entry.leave_type_id}
                        onClick={() => setActiveLeaveFilter(isActive ? null : entry.leave_type_id)}
                        style={{
                          flex: "1",
                          minWidth: "140px",
                          backgroundColor: "#fff",
                          border: isActive ? "2px solid #0DDFAB" : "1px solid #E5E7EB",
                          borderRadius: "8px",
                          padding: "8px 14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "600", color: "#1D1D1D" }}>{entry.leave_type_name}</span>
                        <div style={{
                          width: "28px", height: "28px",
                          borderRadius: "6px",
                          backgroundColor: "rgba(13, 223, 171, 0.1)",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          color: "#0DDFAB"
                        }}>
                          <span style={{ display: 'inline-block', width: '14px', height: '14px', flexShrink: 0, backgroundColor: 'currentColor', mask: `url('/assets/images/${getLeaveIconPath(entry.leave_type_name)}') no-repeat center / contain`, WebkitMask: `url('/assets/images/${getLeaveIconPath(entry.leave_type_name)}') no-repeat center / contain`, transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <RepeaterForm
                  inputFields={inputFields}
                  setInputFields={setInputFields}
                  filterLeaveTypeId={activeLeaveFilter}
                />
              </div>
            )}

            {/* Tab 2: Attendance Policy */}
            {activeTab === 2 && (
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-3 mb-3">
                    <div className="float-input-wrap">
                      <input
                        type="number"
                        id="lateComingLeniency"
                        placeholder=" "
                        value={lateComingLenency}
                        onChange={(e) => setLateComingLenency(e.target.value)}
                        style={{ lineHeight: '44px' }}
                      />
                      <label htmlFor="lateComingLeniency">
                        Late Coming Leniency Time
                        <Tooltip title="Enter number of minutes an employee is allowed to come late without any penalty">
                          <i className="float-label-helper-icon fa fa-info-circle" />
                        </Tooltip>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <div className="float-input-wrap">
                      <input
                        type="number"
                        id="maxLeniencyTime"
                        placeholder=" "
                        value={maxLeniencyTime}
                        onChange={(e) => setMaxLeniencyTime(e.target.value)}
                        style={{ lineHeight: '44px' }}
                      />
                      <label htmlFor="maxLeniencyTime">
                        Max Leniency Time
                        <Tooltip title="Enter the max number in mins you want to restrict users to arrive late to this time. Or leave blank if you don't want to apply this rule">
                          <i className="float-label-helper-icon fa fa-info-circle" />
                        </Tooltip>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <div className="float-input-wrap">
                      <input
                        type="number"
                        id="lateComingBucket"
                        placeholder=" "
                        value={lateComingMontlyBudget}
                        onChange={(e) => setLateComingMontlyBudget(e.target.value)}
                        style={{ lineHeight: '44px' }}
                      />
                      <label htmlFor="lateComingBucket">
                        Late Coming Monthly Bucket
                        <Tooltip title="Enter number of days an employee is allowed to come later than Late Coming Leniency Time without any penalty">
                          <i className="float-label-helper-icon fa fa-info-circle" />
                        </Tooltip>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <div className="float-input-wrap">
                      <input
                        type="number"
                        step="0.1"
                        id="lateComingPenalty"
                        placeholder=" "
                        value={lateComersPlenty}
                        onChange={(e) => setLateComersPlenty(e.target.value)}
                        style={{ lineHeight: '44px' }}
                      />
                      <label htmlFor="lateComingPenalty">
                        Normal Late Comers Penalty
                        <Tooltip title="Enter leaves deducted per late instance after limit.">
                          <i className="float-label-helper-icon fa fa-info-circle" />
                        </Tooltip>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3">
                    <div className="float-input-wrap">
                      <input
                        type="number"
                        step="0.1"
                        id="addLatePenalty"
                        placeholder=" "
                        value={addLateComersPenalty}
                        onChange={(e) => setAddLateComersPenalty(e.target.value)}
                        style={{ lineHeight: '44px' }}
                      />
                      <label htmlFor="addLatePenalty">
                        Add Late Comers Penalty
                        <Tooltip title="Add additional penalty in case if Max Leniency Time is exceeded. It will bypass the penalty of Normal Late Comers Penalty and will apply this one instead">
                          <i className="float-label-helper-icon fa fa-info-circle" />
                        </Tooltip>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 mb-3 d-flex align-items-center" style={{ height: '44px' }}>
                    <div className="form-check mb-0 d-flex align-items-center" style={{ gap: "8px" }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="overtimeAllowed"
                        checked={overtime_allowed}
                        onChange={(e) => {
                          const val = e.target.checked;
                          setOvertimeAllowed(val);
                          if (val) {
                            const newData = [...overtimeLogics];
                            if (newData[0]) newData[0].active = true;
                            setOvertimeLogics(newData);
                          }
                        }}
                        style={{ width: "18px", height: "18px", cursor: "pointer", marginTop: "0", flexShrink: 0 }}
                      />
                      <label className="form-check-label mb-0" htmlFor="overtimeAllowed" style={{ fontSize: "14px", color: "#787878", cursor: "pointer", lineHeight: 1, whiteSpace: "nowrap" }}>
                        Allow Overtime
                        <Tooltip title="Check to allow overtime for employees.">
                          <i className="fa fa-info-circle ms-1" style={{ fontSize: "10px", color: "#1D1D1D", cursor: "help" }} />
                        </Tooltip>
                      </label>
                    </div>
                  </div>

                  {overtime_allowed && (
                    <div className="col-12 mt-3">
                      <h6 className="mb-3 text-muted d-inline-block" style={{ fontSize: '14px', fontWeight: '600' }}>
                        Overtime Configurations{" "}
                        <Tooltip title="Configure granular overtime rules (Hourly, Payment, Leave) for different day types.">
                          <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '13px', color: '#1D1D1D' }} />
                        </Tooltip>
                      </h6>
                      <div className="listing-table-wrapper">
                    <table className="table mb-0 align-middle custom-table listing-table shift-plan-table" style={{ width: "100%", tableLayout: "fixed" }}>
                      <thead>
                        <tr className="tableHeaderbg">
                          <th style={{ width: "10%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Day Type
                            <Tooltip title="Type of day for which overtime logic is applied.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "10%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Hourly Adj.
                            <Tooltip title="Toggle to adjust overtime hours into the employee's work hours.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "11%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            OT Payment
                            <Tooltip title="Toggle to enable monetary payment for overtime hours.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "8%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Rate
                            <Tooltip title="Enter the flat rate per overtime hour.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "10%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Leave Adj.
                            <Tooltip title="Toggle to reward overtime hours as leave balance.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "11%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Leaves Adj.
                            <Tooltip title="Set the maximum number of leave days an employee can earn from overtime.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "9%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Priority
                            <Tooltip title="Select whether Hourly Adjustment or Policy Reward (Pay/Leave) takes precedence.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "13%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Adj. Cycle
                            <Tooltip title="Frequency for calculating and applying overtime rewards.">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "9%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            Multiplier
                            <Tooltip title="Multiplier applied to overtime hours (e.g., 1.5x, 2x).">
                              <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                            </Tooltip>
                          </th>
                          <th style={{ width: "9%", padding: "10px 8px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>Active</th>
                        </tr>
                      </thead>
                          <tbody>
                            {overtimeLogics.map((logic, index) => (
                              <tr key={logic.day_type || index}>
                                <td className="fw-semibold" style={{ padding: '12px 16px' }}>{logic.day_type}</td>
                                <td style={{ padding: '4px' }}>
                                  <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={logic.hourly_adjustment} disabled={!logic.active}
                                      onChange={(e) => { const d = [...overtimeLogics]; d[index].hourly_adjustment = e.target.checked; setOvertimeLogics(d); }} />
                                  </div>
                                </td>
                                <td style={{ padding: '4px' }}>
                                  <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={logic.overtime_payment} disabled={!logic.active}
                                      onChange={(e) => { const d = [...overtimeLogics]; d[index].overtime_payment = e.target.checked; setOvertimeLogics(d); }} />
                                  </div>
                                </td>
                                <td>
                                  <input type="number" className="form-control form-control-sm"
                                    style={{ borderRadius: '8px', width: '100%', height: '34px' }}
                                    placeholder="Rate" value={logic.rate_payment} disabled={!logic.active || !logic.overtime_payment}
                                    onChange={(e) => { const d = [...overtimeLogics]; d[index].rate_payment = e.target.value; setOvertimeLogics(d); }} />
                                </td>
                                <td style={{ padding: '4px' }}>
                                  <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={logic.leave_adjustment} disabled={!logic.active}
                                      onChange={(e) => { const d = [...overtimeLogics]; d[index].leave_adjustment = e.target.checked; setOvertimeLogics(d); }} />
                                  </div>
                                </td>
                                <td>
                                  <input type="number" className="form-control form-control-sm"
                                    style={{ borderRadius: '8px', width: '100%', height: '34px' }}
                                    placeholder="Adjusted" value={logic.leave_unit_hours} disabled={!logic.active || !logic.leave_adjustment}
                                    onChange={(e) => { const d = [...overtimeLogics]; d[index].leave_unit_hours = e.target.value; setOvertimeLogics(d); }} />
                                </td>
                                <td>
                                  <Switch size="small" checked={logic.adjustment_priority === "Policy Adjustment"} disabled={!logic.active}
                                    checkedChildren={(logic.overtime_payment && logic.leave_adjustment) ? "Reward" : (logic.overtime_payment ? "Pay" : (logic.leave_adjustment ? "Leave" : "Policy"))}
                                    unCheckedChildren="Hourly"
                                    style={{ backgroundColor: logic.adjustment_priority === "Policy Adjustment" ? "#0DDFAB" : "" }}
                                    onChange={(checked) => { const d = [...overtimeLogics]; d[index].adjustment_priority = checked ? "Policy Adjustment" : "Hourly Adjustment"; setOvertimeLogics(d); }} />
                                </td>
                                <td>
                                  <Select
                                    className="shift-table-select"
                                    popupClassName="shift-table-select-dropdown"
                                    style={{ width: '100%' }}
                                    value={logic.adjustment_cycle}
                                    disabled={!logic.active}
                                    onChange={(val) => { const d = [...overtimeLogics]; d[index].adjustment_cycle = val; setOvertimeLogics(d); }}
                                  >
                                    <Option value="Daily">Daily</Option>
                                    <Option value="Weekly">Weekly</Option>
                                    <Option value="Fortnightly">Fortnightly</Option>
                                    <Option value="Monthly">Monthly</Option>
                                    <Option value="Quarterly">Quarterly</Option>
                                    <Option value="Semi-Annually">Semi-Annually</Option>
                                    <Option value="Annually">Annually</Option>
                                  </Select>
                                </td>
                                <td>
                                  <Select
                                    className="shift-table-select"
                                    popupClassName="shift-table-select-dropdown"
                                    style={{ width: '100%' }}
                                    value={logic.multiplier}
                                    disabled={!logic.active}
                                    onChange={(val) => { const d = [...overtimeLogics]; d[index].multiplier = Number(val); setOvertimeLogics(d); }}
                                  >
                                    <Option value={1}>1x</Option>
                                    <Option value={1.5}>1.5x</Option>
                                    <Option value={2}>2x</Option>
                                    <Option value={2.5}>2.5x</Option>
                                    <Option value={3}>3x</Option>
                                  </Select>
                                </td>
                                <td style={{ padding: '4px' }}>
                                  <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={logic.active}
                                      onChange={(e) => {
                                        const d = [...overtimeLogics];
                                        d[index].active = e.target.checked;
                                        setOvertimeLogics(d);
                                        if (!e.target.checked && !d.some(l => l.active)) setOvertimeAllowed(false);
                                      }} />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default AddPolicy;
